import { render, staticRenderFns } from "./PopoverButton.vue?vue&type=template&id=442fc13c&"
import script from "./PopoverButton.vue?vue&type=script&lang=js&"
export * from "./PopoverButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports